module.exports = __webpack_public_path__ + "img/T4-B-rc_14.319f7a18.png";